import BookmarksForm from './BookmarksForm';
export default BookmarksForm;